import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { AccountBalance, Build, Description, HowToVote } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const Dashboard: React.FC = () => {
  const { user } = useAuth();
  const cards = [
    { title: 'Levy Balance', value: '$5,420.00', icon: <AccountBalance />, color: '#1976d2' },
    { title: 'Open Requests', value: '3', icon: <Build />, color: '#ed6c02' },
    { title: 'Documents', value: '12', icon: <Description />, color: '#2e7d32' },
    { title: 'Active Polls', value: '2', icon: <HowToVote />, color: '#9c27b0' }
  ];
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Welcome, {user?.name || 'Owner'}</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' }, gap: 3 }}>
        {cards.map(c => (
          <Paper key={c.title} sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ p: 2, borderRadius: 2, bgcolor: `${c.color}20`, color: c.color }}>{c.icon}</Box>
            <Box><Typography variant="h5" fontWeight="bold">{c.value}</Typography><Typography color="text.secondary">{c.title}</Typography></Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};
export default Dashboard;
